import {
  createLoyaltyEarningRule as publicCreateLoyaltyEarningRule,
  bulkCreateLoyaltyEarningRules as publicBulkCreateLoyaltyEarningRules,
  createCustomLoyaltyEarningRule as publicCreateCustomLoyaltyEarningRule,
  getLoyaltyEarningRule as publicGetLoyaltyEarningRule,
  updateLoyaltyEarningRule as publicUpdateLoyaltyEarningRule,
  deleteLoyaltyEarningRule as publicDeleteLoyaltyEarningRule,
  deleteAutomationEarningRule as publicDeleteAutomationEarningRule,
  listEarningRules as publicListEarningRules,
} from './loyalty-v1-loyalty-earning-rule-earning-rules.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onLoyaltyEarningRuleCreated as publicOnLoyaltyEarningRuleCreated } from './loyalty-v1-loyalty-earning-rule-earning-rules.public.js';
import { onLoyaltyEarningRuleDeleted as publicOnLoyaltyEarningRuleDeleted } from './loyalty-v1-loyalty-earning-rule-earning-rules.public.js';
import { onLoyaltyEarningRuleUpdated as publicOnLoyaltyEarningRuleUpdated } from './loyalty-v1-loyalty-earning-rule-earning-rules.public.js';

export const createLoyaltyEarningRule: MaybeContext<
  BuildRESTFunction<typeof publicCreateLoyaltyEarningRule> &
    typeof publicCreateLoyaltyEarningRule
> = /*#__PURE__*/ createRESTModule(publicCreateLoyaltyEarningRule);
export const bulkCreateLoyaltyEarningRules: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateLoyaltyEarningRules> &
    typeof publicBulkCreateLoyaltyEarningRules
> = /*#__PURE__*/ createRESTModule(publicBulkCreateLoyaltyEarningRules);
export const createCustomLoyaltyEarningRule: MaybeContext<
  BuildRESTFunction<typeof publicCreateCustomLoyaltyEarningRule> &
    typeof publicCreateCustomLoyaltyEarningRule
> = /*#__PURE__*/ createRESTModule(publicCreateCustomLoyaltyEarningRule);
export const getLoyaltyEarningRule: MaybeContext<
  BuildRESTFunction<typeof publicGetLoyaltyEarningRule> &
    typeof publicGetLoyaltyEarningRule
> = /*#__PURE__*/ createRESTModule(publicGetLoyaltyEarningRule);
export const updateLoyaltyEarningRule: MaybeContext<
  BuildRESTFunction<typeof publicUpdateLoyaltyEarningRule> &
    typeof publicUpdateLoyaltyEarningRule
> = /*#__PURE__*/ createRESTModule(publicUpdateLoyaltyEarningRule);
export const deleteLoyaltyEarningRule: MaybeContext<
  BuildRESTFunction<typeof publicDeleteLoyaltyEarningRule> &
    typeof publicDeleteLoyaltyEarningRule
> = /*#__PURE__*/ createRESTModule(publicDeleteLoyaltyEarningRule);
export const deleteAutomationEarningRule: MaybeContext<
  BuildRESTFunction<typeof publicDeleteAutomationEarningRule> &
    typeof publicDeleteAutomationEarningRule
> = /*#__PURE__*/ createRESTModule(publicDeleteAutomationEarningRule);
export const listEarningRules: MaybeContext<
  BuildRESTFunction<typeof publicListEarningRules> &
    typeof publicListEarningRules
> = /*#__PURE__*/ createRESTModule(publicListEarningRules);
/**
 * Triggered when an earning rule is created.
 */
export const onLoyaltyEarningRuleCreated: BuildEventDefinition<
  typeof publicOnLoyaltyEarningRuleCreated
> &
  typeof publicOnLoyaltyEarningRuleCreated = /*#__PURE__*/ createEventModule(
  publicOnLoyaltyEarningRuleCreated
);
/**
 * Triggered when an earning rule is deleted.
 */
export const onLoyaltyEarningRuleDeleted: BuildEventDefinition<
  typeof publicOnLoyaltyEarningRuleDeleted
> &
  typeof publicOnLoyaltyEarningRuleDeleted = /*#__PURE__*/ createEventModule(
  publicOnLoyaltyEarningRuleDeleted
);
/**
 * Triggered when an earning rule is updated.
 */
export const onLoyaltyEarningRuleUpdated: BuildEventDefinition<
  typeof publicOnLoyaltyEarningRuleUpdated
> &
  typeof publicOnLoyaltyEarningRuleUpdated = /*#__PURE__*/ createEventModule(
  publicOnLoyaltyEarningRuleUpdated
);

export {
  Status,
  LoyaltyEarningRuleTypeTagType,
  Type,
  V1Type,
  WebhookIdentityType,
} from './loyalty-v1-loyalty-earning-rule-earning-rules.universal.js';
export {
  LoyaltyEarningRule,
  LoyaltyEarningRuleTypeOneOf,
  FixedAmount,
  FixedAmountConfig,
  ConversionRate,
  ConversionRateConfig,
  Metadata,
  LoyaltyEarningRuleTypeTag,
  AutomationTriggerFilter,
  CacheInvalidated,
  EarningRuleDisabled,
  CreateLoyaltyEarningRuleRequest,
  CreateLoyaltyEarningRuleResponse,
  BulkCreateLoyaltyEarningRulesRequest,
  BulkCreateLoyaltyEarningRulesResponse,
  BulkLoyaltyEarningRuleResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  CreateCustomLoyaltyEarningRuleRequest,
  CustomLoyaltyEarningRule,
  CustomLoyaltyEarningRuleTypeOneOf,
  CreateCustomLoyaltyEarningRuleResponse,
  GetLoyaltyEarningRuleRequest,
  GetLoyaltyEarningRuleResponse,
  UpdateLoyaltyEarningRuleRequest,
  UpdateLoyaltyEarningRuleResponse,
  DeleteLoyaltyEarningRuleRequest,
  DeleteLoyaltyEarningRuleResponse,
  DeleteAutomationEarningRuleRequest,
  DeleteAutomationEarningRuleResponse,
  ListEarningRulesRequest,
  ListEarningRulesResponse,
  ListEarningRulesInTierRequest,
  CursorPaging,
  ListEarningRulesInTierResponse,
  PagingMetadataV2,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  InvalidateEarningRuleCacheRequest,
  InvalidateEarningRuleCacheResponse,
  AppInstallationInLoyaltySite,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  LoyaltyEarningRuleCreatedEnvelope,
  LoyaltyEarningRuleDeletedEnvelope,
  LoyaltyEarningRuleUpdatedEnvelope,
  CreateCustomLoyaltyEarningRuleOptions,
  UpdateLoyaltyEarningRule,
  DeleteLoyaltyEarningRuleOptions,
  ListEarningRulesOptions,
} from './loyalty-v1-loyalty-earning-rule-earning-rules.universal.js';
export {
  StatusWithLiterals,
  LoyaltyEarningRuleTypeTagTypeWithLiterals,
  TypeWithLiterals,
  V1TypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './loyalty-v1-loyalty-earning-rule-earning-rules.universal.js';
